<template>
  <v-container class="px-5 col-12 entity-tree-container">
    <kiosk-view ref="kiosk-view-dialog" :entityList="entityList" :currencies="currencies" :loadEntities="loadEntities" />
    <material-card color="teal" class="mb-0" style="margin-top: 32px;">
      <template v-slot:header>
        <div class="px-3">
          <h4 class="title font-weight-light mb-0">Kiosk Panel</h4>
        </div>
        <v-spacer />
        <v-text-field
          label="Search"
          v-model="search"
          class="col-3 mt-3"
          style="min-width: 100px;"
          dense
          :autocomplete="false"
          hide-details
        />

        <v-btn @click="loadEntities()" icon class="mt-1 mr-3">
          <v-icon>refresh</v-icon>
        </v-btn>


        <v-btn
          v-if="$store.state.auth.checkAccess({key: 'kiosk.entity.crud', value: true})"
          icon
          class="mt-1 mr-3"
          title="Create new Kiosk"
          @click="$refs['kiosk-view-dialog'].open(null, true)"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-container class="col-12 pa-0" :style="`height: calc(100vh - 130px - ${!$store.state.auth.default_user ? '0px' : '24px'}); overflow: auto;`">

        <v-progress-linear
          indeterminate
          color="green"
          v-if="loading"
        ></v-progress-linear>

        <vue-ads-table
          :columns="columns"
          :rows="treeData"
          :filter="filterStr"
          :classes="classes"
          @filter-change="filterChanged"
        >
          <template slot="parent_id" slot-scope="props">
            <v-select
              :value="props.row.parent_id"
              :return-object="false"
              :items="entityList(props.row)"
              @change="updateEntity(props, $event)"
              hide-details
              style="max-width: 210px; margin-top: -10px"
            ></v-select>
          </template>
          <template slot="balance" slot-scope="props">
            <div class="kiosk-balances">
              <template v-for="balance in props.row.wallet">
              <span class="mr-2 pr-2">
                {{ balance.currency }}{{ balance.balance }}
              </span>
              </template>
            </div>
          </template>
          <template slot="action" slot-scope="props">
            <v-btn
              icon
              color="teal darken-3"
              @click="$refs['kiosk-view-dialog'].open(props.row.entity_id)"
            >
              <v-icon>info</v-icon>
            </v-btn>
          </template>
          <template slot="frozen" slot-scope="props">
            <v-checkbox
              v-model="props.row.frozen"
              readonly
              hide-details
              class="mt-0"
            />
          </template>
          <template slot="sort-icon" slot-scope="props">
            <!--            <v-icon small>{{ props.direction === null ? 'mdi-sort' : (props.direction ? 'mdi-sort-descending' : 'mdi-sort-ascending') }}</v-icon>-->
          </template>
          <template slot="toggle-children-icon" slot-scope="props">
            <v-icon>{{ props.expanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
          </template>
        </vue-ads-table>

      </v-container>
    </material-card>
  </v-container>
</template>

<style>

  .entity-control_card .rotate {
    -moz-transition: all 0.2s linear;
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
  }

  .entity-control_card .rotate.down {
    -ms-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }

  .kiosk-action-cell {
    width: 50px;
  }

  .kiosk-inner-border {
    padding: 0px;
    white-space: nowrap;
  }

  .kiosk-inner-border > span {
    padding: 8px 5px;
    border-left: 1px dashed #EEE;
  }

  .kiosk-balances span:not(:last-child) {
    border-right: 1px solid #CCC;
  }

</style>

<script>
  import { API } from '@/utils/api'
  import { debounce, remove, map } from 'lodash'

  import 'vue-ads-table-tree/dist/vue-ads-table-tree.css'
  import { VueAdsTable } from 'vue-ads-table-tree'

  export default {
    components: {
      VueAdsTable,
      KioskView: () => import('@/components/kiosk/entity-tree/KioskView'),
    },

    data: () => ({
      data: [],
      treeData: [],
      initData: [],

      infoDialog: false,
      loading: false,

      currencies: [],

      expandedMap: {},

      search: '',
      filterStr: '',
      classes: {
        table: {
          'vue-ads-border': true,
          'vue-ads-w-full': true
        },
        'all/': {
          'vue-ads-border-b': true
        },
        'all/-2_': {
          'kiosk-action-cell': true
        },
        '0/all': {
          'vue-ads-px-4': true,
          'vue-ads-py-2': true,
          'vue-ads-border-r': true,
        },
        '1_/all': {
          'vue-ads-px-4': true,
          'vue-ads-py-1': true,
          'vue-ads-border-r': true,
        },
        '1_/0': {
          'vue-ads-py-1': false,
          'kiosk-inner-border': true,
        },
        'even/': {
          'hover:vue-ads-bg-gray-200': true,
          'vue-ads-bg-gray-100': true,
          'vue-ads-border-b': true,
        },
        '0/': {
          'vue-ads-cursor-pointer': true,
          'vue-ads-border-r': true,
          'vue-ads-text-sm': true,
          'vue-ads-text-left': true,
        }
      },
      columns: [
        {
          property: 'name',
          title: 'Project',
          direction: null,
          filterable: true,
          collapseIcon: true,
        },
        {
          property: 'entity_id',
          title: 'EntityID',
          direction: null,
          filterable: true,
        },
        {
          property: 'host',
          title: 'Host',
          direction: null,
          filterable: true,
        },
        {
          property: 'description',
          title: 'Description',
          direction: null,
          filterable: true,
        },
        {
          property: 'balance',
          title: 'Balance',
          direction: null,
          filterable: true,
        },
        {
          property: 'frozen',
          title: 'Frozen',
          direction: null
        },
        {
          property: 'action',
          title: '',
          direction: null
        },
      ],
    }),

    mounted () {
      this.loadEntities()
    },

    computed: {},

    watch: {
      search: debounce(function () {
        this.filterStr = this.search
      }, 500)
    },

    methods: {

      entityList (self) {
        let list = map(this.data, (r) => ({ text: r.name, value: r.entity_id }))
        remove(list, (r) => r.value == self.entity_id)
        return list
      },

      cl (d) {
        console.log(d)
      },

      updateEntity (entity, newValue) {
        entity.row.parent_id = newValue

        let treeData = [ ...this.treeData ]

        this.treeData = []
        this.treeData = treeData
      },

      filterChanged (filter) {
        this.filter = filter
      },

      loadEntities () {
        this.loading = true

        this.expandedMap = {}
        this.getExpanded(this.treeData)

        return API.call('/kiosk/entities/list.json', { expanded: this.expandedMap }).then(resp => {

          this.data = resp.raw
          this.treeData = resp.data
          this.currencies = resp.data[0] && resp.data[0].wallet ? map(resp.data[0].wallet, (o) => o.currency) : this.$store.state.auth.currencies

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      getExpanded (data) {
        for (let row of data) {
          if (row._showChildren) {
            this.expandedMap[row.entity_id] = row._showChildren
            if (row._children) {
              this.getExpanded(row._children)
            }
          }
        }
      }

    }

  }
</script>
